import { AnyAction } from "redux";
import { FETCH_APPSTORE_VERSION } from "../actions/appstore_version";
import { AppstoreVersion } from "../models";

const initialState: AppstoreVersion = {
    version: "",
};

const appstoreVersionReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_APPSTORE_VERSION:
            return {
                ...state,
                version: action.payload,
            };

        default:
            return state;
    }
};

export default appstoreVersionReducer;
